<template>
    <Link :href="href" :class="classes">
        <slot />
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';

    export default {
        components: {
            Link,
        },
        props: ['href', 'active'],

        computed: {
            classes() {
                return this.active
                    ? 'inline-flex items-center py-1 text-lg font-bold leading-snug text-red-dark focus:outline-none focus:border-indigo-700 transition'
                    : 'inline-flex items-center py-1 text-lg border-transparent font-medium leading-snug hover:font-bold hover:text-red-dark hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition'
            }
        }
    }
</script>
